//
//
//
//
//
//
//
//

export default {
  props: {
    label: String,
    placeholder: String,
    isTextarea: {
      type: Boolean,
      default: false
    },
    rows: {
      type: Number,
      default: 1
    },
    autoGrow: {
      type: Boolean,
      default: false
    },
    value: [String, Number, Object],
    maxlength: {
      type: Number,
      default: 250
    },
    disabled: Boolean,
    colSize: {
      type: Number,
      default: 3
    },
    numeric: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  computed: {
    internalValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        var filtered = this.numeric ? String(val).replace(/\D/g, '') : val;
        this.$emit('input', filtered);
      }
    }
  },
  methods: {
    onKeyPress: function onKeyPress(event) {
      if (this.numeric && !/[0-9]/.test(event.key)) {
        event.preventDefault();
      }
    }
  }
};